var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Getter } from '@devexpress/dx-react-core';
import { GroupingState, IntegratedGrouping, IntegratedSorting, RowDetailState, SelectionState, SortingState } from '@devexpress/dx-react-grid';
import { Grid, Table, TableHeaderRow, TableRowDetail, TableSelection, VirtualTable, TableGroupRow } from '@devexpress/dx-react-grid-material-ui';
import classNames from 'classnames';
import { upperCase, xor } from 'lodash';
import * as React from 'react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { iconLight } from '../../Styles/Colours';
import { Button, ButtonMode, ButtonSize } from '../Button';
import { FloatingLinearProgress } from '../FloatingLinearProgress';
import { ArrowDownIcon, ArrowUpIcon } from '../Icons';
import styles from './DataTable.module.css';
import { LoadMoreFooter } from './LoadMoreFooter';
import { ProductPackGroup } from '../../Contracts/MedicationModels';
function RootComponent(props) {
    return (React.createElement(Grid.Root, __assign({}, props, { style: {
            width: '100%'
        } })));
}
function GroupRow(props) {
    var groupLabel = '';
    switch (props.rowProps.row.value) {
        case ProductPackGroup.Unrestricted:
        case ProductPackGroup.Restricted:
            groupLabel = 'PBS/RPBS ' + upperCase(props.rowProps.row.value);
            break;
        case ProductPackGroup.AuthorityRequiredStreamlined:
            groupLabel = 'PBS/RPBS ' + upperCase('StreamlinedAuthority');
            break;
        case ProductPackGroup.AuthorityRequired:
            groupLabel = 'PBS/RPBS ' + upperCase('Authority');
            break;
        case ProductPackGroup.Private:
            groupLabel = upperCase(props.rowProps.row.value);
            break;
        case ProductPackGroup.S100:
            groupLabel = 'S100';
            break;
    }
    return (React.createElement("tr", { className: styles.groupRow },
        React.createElement("td", { className: styles.groupCell, colSpan: 11 }, groupLabel)));
}
export function StyledTableCell(props) {
    return React.createElement(Table.Cell, __assign({}, props, { className: classNames(styles.cell, props.className) }));
}
export var ParentStyledTableCell = function (props) {
    var parentStyle = props.parentStyle, otherProps = __rest(props, ["parentStyle"]);
    return React.createElement(Table.Cell, __assign({}, otherProps, { className: classNames(styles.cell, parentStyle) }));
};
function TableComponent(props) {
    var testId = props.testId, otherProps = __rest(props, ["testId"]);
    return React.createElement(Table.Table, __assign({}, otherProps, { "data-test-id": "datatable" + (testId ? "-" + testId : '') + "-table" }));
}
function TableBody(props) {
    return React.createElement(Table.TableBody, __assign({}, props, { className: styles.body }));
}
export var ParentStyledHeaderCell = function (props) {
    var parentStyle = props.parentStyle, otherProps = __rest(props, ["parentStyle"]);
    var parentStyleClasses = parentStyle !== undefined ? parentStyle : null;
    return (React.createElement(TableHeaderRow.Cell, __assign({}, otherProps, { className: classNames(styles.headerCell, parentStyleClasses) }), props.children));
};
function HeaderCell(props) {
    return (React.createElement(TableHeaderRow.Cell, __assign({}, props, { className: styles.headerCell }), props.children));
}
function HeaderRow(props) {
    return React.createElement(TableHeaderRow.Row, __assign({}, props, { className: styles.headerRow }));
}
function TableHeaderStub(props) {
    return React.createElement(Table.StubHeaderCell, __assign({}, props, { className: styles.headerStub }));
}
export function TableRow(props) {
    return React.createElement(Table.Row, __assign({}, props, { className: styles.row }));
}
var RowComponent = function (props) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h;
    var selectByRowClick = props.selectByRowClick, highlighted = props.highlighted, onToggle = props.onToggle, otherProps = __rest(props, ["selectByRowClick", "highlighted", "onToggle"]);
    var rowStyles = classNames(styles.selectionRow, (_a = {}, _a[styles.selected] = highlighted, _a));
    var testId = (_e = (_c = (_b = props.tableRow.row) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : (_d = props.tableRow.row) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : undefined;
    var testName = (_h = (_g = (_f = props.tableRow.row) === null || _f === void 0 ? void 0 : _f.name) === null || _g === void 0 ? void 0 : _g.slice(0, 20)) !== null && _h !== void 0 ? _h : undefined;
    return (React.createElement(Table.Row, __assign({}, otherProps, { row: props.tableRow.row, onClick: props.onToggle, className: rowStyles, "data-test-id": testId, "data-test-name": testName })));
};
export var HoverOnlyButtonGroup = function (props) {
    return React.createElement("div", { className: styles.hoverOnlyButtons }, props.children);
};
// Currently hardcoded to white background, once we encounter multiple variants
// we can change the implementation to be a passed in component
function RowDetailCellComponent(props) {
    return React.createElement(TableRowDetail.Cell, __assign({}, props, { className: styles.rowDetailCellComponent }));
}
function RowDetailRowComponent(props) {
    return React.createElement(TableRowDetail.Row, __assign({}, props, { className: styles.rowDetailRowComponent }));
}
export function DataTable(props) {
    var _a;
    var _b, _c, _d, _e, _f;
    var containerRef = useRef(null);
    var vtRef = useRef(null);
    var _g = __read(useState(600), 2), windowHeight = _g[0], setWindowHeight = _g[1];
    var calcHeight = useCallback(function () {
        if (containerRef.current) {
            var rect = containerRef.current.getBoundingClientRect();
            if (windowHeight !== rect.height)
                setWindowHeight(rect.height);
        }
    }, [windowHeight, containerRef.current]);
    var scrollToRow = useCallback(function (rowId) {
        if (vtRef.current)
            vtRef.current.scrollToRow(rowId);
    }, [vtRef]);
    useEffect(function () {
        if (props.scrollToRowOnLoad && props.loading === false) {
            setTimeout(function () { return scrollToRow(props.scrollToRowOnLoad); }, 200);
        }
    }, [props.scrollToRowOnLoad, props.loading]);
    useEffect(function () {
        window.addEventListener('resize', calcHeight);
        return function () {
            window.removeEventListener('resize', calcHeight);
        };
    }, []);
    useEffect(function () {
        calcHeight();
    });
    var handleSelection = useCallback(function (selectedIds) {
        if (props.rowSelection) {
            var changed_1 = xor(props.rowSelection.selectedIds, selectedIds);
            if (changed_1.length > 0) {
                var row = props.data.find(function (it) { return props.getRowId(it) === changed_1[0]; });
                if (row)
                    props.rowSelection.onSelect(row);
            }
        }
    }, [props.data, (_b = props.rowSelection) === null || _b === void 0 ? void 0 : _b.selectedIds]);
    var handleRowExpansion = useCallback(function (expandedIds) {
        if (props.rowExpansion) {
            var changed_2 = xor(props.rowExpansion.expandedIds, expandedIds);
            if (changed_2.length > 0) {
                var row = props.data.find(function (it) { return props.getRowId(it) === changed_2[0]; });
                if (row)
                    props.rowExpansion.onExpand(row);
            }
        }
    }, [props.data, (_c = props.rowExpansion) === null || _c === void 0 ? void 0 : _c.expandedIds]);
    var ToggleCell = useCallback(function (toggleCellProps) {
        var _a, _b;
        var expanded = toggleCellProps.expanded, onToggle = toggleCellProps.onToggle, others = __rest(toggleCellProps, ["expanded", "onToggle"]);
        var onClick = function (event) {
            event.stopPropagation();
            event.preventDefault();
            onToggle();
        };
        return (React.createElement(TableRowDetail.Cell, __assign({}, others, { className: styles.detailCell }),
            React.createElement(Button, { iconOnly: true, onClick: onClick, size: (_b = (_a = props.rowExpansion) === null || _a === void 0 ? void 0 : _a.buttonSize) !== null && _b !== void 0 ? _b : ButtonSize.medium, mode: ButtonMode.text, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'expand' }, expanded ? (React.createElement(ArrowUpIcon, { noPadding: true, color: iconLight })) : (React.createElement(ArrowDownIcon, { noPadding: true, color: iconLight })))));
    }, [(_d = props.rowExpansion) === null || _d === void 0 ? void 0 : _d.buttonSize]);
    var tableStyles = classNames(styles.tableContainer, (_a = {},
        _a[styles.cellsInteractive] = props.rowSelection,
        _a));
    var limitedData = !!Number(props.limit) && props.limit !== undefined
        ? props.data.filter(function (it, index) {
            return !!Number(props.limit) && props.limit !== undefined ? index < props.limit : true;
        })
        : props.data;
    var showLoadMoreFooter = !!props.limit && props.data.length > props.limit;
    var tableHeight = showLoadMoreFooter ? windowHeight - 50 : windowHeight;
    var SortLabelComponent = useMemo(function () {
        return props.hideButtonOnDisabledSortColumns
            ? function (sortLabelProps) {
                if (sortLabelProps.disabled) {
                    return React.createElement(React.Fragment, null, sortLabelProps.children);
                }
                else {
                    return (React.createElement(TableHeaderRow.SortLabel, __assign({}, sortLabelProps), sortLabelProps.children));
                }
            }
            : TableHeaderRow.SortLabel;
    }, [props.hideButtonOnDisabledSortColumns]);
    return (React.createElement("div", { className: tableStyles, ref: containerRef },
        React.createElement(FloatingLinearProgress, { display: props.loading }),
        React.createElement(Grid, { rows: limitedData, getRowId: props.getRowId, rootComponent: RootComponent, columns: props.columns },
            !!props.rowExpansion && (React.createElement(RowDetailState, { expandedRowIds: props.rowExpansion.expandedIds, onExpandedRowIdsChange: handleRowExpansion })),
            React.createElement(SortingState, { defaultSorting: props.defaultSort, columnExtensions: props.sortingControl, columnSortingEnabled: !props.disableColumnSorting }),
            React.createElement(IntegratedSorting, { columnExtensions: props.customSort }),
            props.isMedicationBrowserGrid && (React.createElement(GroupingState, { grouping: [{ columnName: 'productPackGroup' }], expandedGroups: [
                    ProductPackGroup.Unrestricted,
                    ProductPackGroup.Restricted,
                    ProductPackGroup.AuthorityRequiredStreamlined,
                    ProductPackGroup.AuthorityRequired,
                    ProductPackGroup.Private,
                    ProductPackGroup.S100
                ] })),
            props.isMedicationBrowserGrid && React.createElement(IntegratedGrouping, null),
            React.createElement(VirtualTable, { columnExtensions: props.columnExtensions, height: tableHeight, cellComponent: props.cellComponent, tableComponent: function (tableProps) { return React.createElement(TableComponent, __assign({}, tableProps, { testId: props.testId })); }, bodyComponent: TableBody, rowComponent: TableRow, stubHeaderCellComponent: props.stubComponent ? props.stubComponent : TableHeaderStub, estimatedRowHeight: 48, ref: vtRef }),
            !!props.rowExpansion && (React.createElement(TableRowDetail, { toggleCellComponent: ToggleCell, cellComponent: RowDetailCellComponent, rowComponent: RowDetailRowComponent, toggleColumnWidth: props.rowExpansion.toggleColumnWidth, contentComponent: props.rowExpansion.content })),
            !!props.rowSelection && (React.createElement(SelectionState, { selection: (_f = (_e = props.rowSelection) === null || _e === void 0 ? void 0 : _e.selectedIds) !== null && _f !== void 0 ? _f : [], onSelectionChange: handleSelection })),
            !!props.rowExpansion && (React.createElement(Getter, { name: 'tableColumns', computed: function (_a) {
                    var _b, _c;
                    var tableColumns = _a.tableColumns;
                    var _d = __read(tableColumns), detailColumn = _d[0], restColumns = _d.slice(1);
                    var detailColumnWider = __assign(__assign({}, detailColumn), { width: (_c = (_b = props.rowExpansion) === null || _b === void 0 ? void 0 : _b.toggleColumnWidth) !== null && _c !== void 0 ? _c : 64 });
                    return __spreadArray(__spreadArray([], __read(restColumns), false), [detailColumnWider], false);
                } })),
            React.createElement(TableHeaderRow, { cellComponent: props.headerComponent ? props.headerComponent : HeaderCell, showSortingControls: !props.disableColumnSorting, rowComponent: HeaderRow, sortLabelComponent: SortLabelComponent }),
            !!props.rowSelection && (React.createElement(TableSelection, { selectByRowClick: true, highlightRow: true, showSelectionColumn: false, rowComponent: RowComponent })),
            props.isMedicationBrowserGrid && (React.createElement(TableGroupRow, { indentColumnWidth: 1, rowComponent: function (rowProps) { return React.createElement(GroupRow, { rowProps: rowProps }); } }))),
        showLoadMoreFooter && React.createElement(LoadMoreFooter, { showing: props.limit })));
}
